<div class="search-bar" role="search">
  <div class="search-txt" translate="common_search"></div>
  <input #textInput
    type="text"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledBy]="ariaLabelledBy"
    aria-label class="form-control search-input"
    [(ngModel)]="searchText"
    (ngModelChange)='changed($event)' />
  <div class="action-wrapper">
    @if (!searchText) {
      <span mat-icon><i class="ficon-search"></i></span>
    }
    @if (searchText) {
      <button class="ficon-app-x clear-btn" mat-button (click)="clearText()"></button>
    }
  </div>
</div>
